import { render } from "./Aside.vue?vue&type=template&id=7aada994&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=7aada994&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aada994"]])

export default __exports__